"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSortValues = exports.parseUrlFacets = exports.buildConstructorSlugifyDictionary = exports.sharedFacetNameList = exports.getAspectRatio = exports.rulesToSendFilters = void 0;
exports.isSafeRedirectUrl = isSafeRedirectUrl;
const url_1 = require("url");
const slugify_1 = require("../slugify");
const constants_1 = require("../constants");
const constants_2 = require("./constants");
const facetNames_1 = require("./constants/facetNames");
const hardcodedCurationPortalFilters_1 = require("./constants/hardcodedCurationPortalFilters");
const convertInchesToCentimeters = (inchesValue) => {
    return parseFloat(`${Number(inchesValue) * constants_1.INCHES_TO_CM}`).toFixed(0);
};
const rulesToSendFilters = ({ filters, destinationZone = 'US', userSizePreference, shouldAddGroupIdFilter, }) => {
    var _a, _b, _c, _d;
    const facetNames = Object.values(facetNames_1.FACET_NAMES);
    const otherFacets = Object.values(facetNames_1.OTHER_FACETS);
    const curationFacetNames = Object.values(hardcodedCurationPortalFilters_1.CURATION_PORTAL_FACET_NAMES);
    const otherCurationFacetNames = Object.values(hardcodedCurationPortalFilters_1.OTHER_CURATION_PORTAL_FACET_NAMES);
    const allowedFacetNames = [
        ...facetNames,
        ...otherFacets,
        ...curationFacetNames,
        ...otherCurationFacetNames,
        ...facetNames_1.UNIQUE_DESTINATION_ZONES, // for price filters
    ];
    // Remove basic query params from selectedFacets
    const basicQueryParam = ['query', 'hitsPerPage', 'page', 'sort'];
    const filtersToRemove = [
        'has_prints',
        'category',
        'custom__geo_prices',
        'custom__print_all_prices',
        'curation_portal_query',
        'originals_prints',
    ];
    const mergedFiltersToRemove = [...basicQueryParam, ...filtersToRemove];
    const filtersWithoutBasicQueryParams = Object.fromEntries(Object.entries(filters).filter(([key]) => !mergedFiltersToRemove.includes(key)));
    // Format geo_prices
    if ((_a = filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams['geo_prices']) === null || _a === void 0 ? void 0 : _a.length) {
        const ranges = filtersWithoutBasicQueryParams['geo_prices'].map((range) => {
            const [min, max] = range.split('-').map(Number);
            const minPriceInCents = min * 100;
            const maxPriceInCents = max * 100;
            return `${minPriceInCents}-${maxPriceInCents}`;
        });
        filtersWithoutBasicQueryParams[destinationZone] = ranges;
        delete filtersWithoutBasicQueryParams['geo_prices'];
    }
    // Format print_all_prices
    if ((_b = filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams['print_all_prices_values']) === null || _b === void 0 ? void 0 : _b.length) {
        const ranges = filtersWithoutBasicQueryParams['print_all_prices_values'].map((range) => {
            const [min, max] = range.split('-').map(Number);
            const minPriceInCents = min * 100;
            const maxPriceInCents = max * 100;
            return `${minPriceInCents}-${maxPriceInCents}`;
        });
        filtersWithoutBasicQueryParams['print_all_prices'] = ranges;
        delete filtersWithoutBasicQueryParams['print_all_prices_values'];
    }
    // Adding category filter to prints groups request (as we remove category from filters we may receive the correct group_id before final filters)
    if (shouldAddGroupIdFilter) {
        const groupIdArray = filtersWithoutBasicQueryParams['group_id'] || filters['category'];
        const slugifiedGroupIdArray = (groupIdArray || []).map((groupIdValue) => {
            const slugifiedGroupId = (0, slugify_1.slugify)(groupIdValue);
            return (constants_2.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_GROUP_ID_FILTER[slugifiedGroupId] || slugifiedGroupId);
        });
        if (slugifiedGroupIdArray.length > 0) {
            filtersWithoutBasicQueryParams['group_id'] = slugifiedGroupIdArray;
        }
    }
    // normalize value for artwork_category
    if (Boolean(filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams['artwork_category'])) {
        const slugifiedArtworkCategory = (filtersWithoutBasicQueryParams['artwork_category'] || []).map((artworkCategoryValue) => {
            const slugifiedValue = (0, slugify_1.slugify)(artworkCategoryValue);
            return constants_2.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_FILTER[slugifiedValue] || slugifiedValue;
        });
        if (slugifiedArtworkCategory.length > 0) {
            filtersWithoutBasicQueryParams['artwork_category'] = slugifiedArtworkCategory;
        }
    }
    // Formating boolean facets from 'true' to 'True' as expected by Constructor
    for (const key in filtersWithoutBasicQueryParams) {
        if (Array.isArray(filtersWithoutBasicQueryParams[key])) {
            filtersWithoutBasicQueryParams[key] = filtersWithoutBasicQueryParams[key].map((filterValue) => filterValue === 'true' ? 'True' : filterValue);
        }
    }
    // Format Custom dimensions to always send centimeters
    if (Boolean(filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams['width'])) {
        if (userSizePreference === 'in') {
            const [widthMin, widthMax] = (((_c = filtersWithoutBasicQueryParams['width']) === null || _c === void 0 ? void 0 : _c[0]) || '').split('-');
            filtersWithoutBasicQueryParams['width'] = [
                `${convertInchesToCentimeters(widthMin)}-${convertInchesToCentimeters(widthMax)}`,
            ];
        }
    }
    if (Boolean(filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams['height'])) {
        if (userSizePreference === 'in') {
            const [heightMin, heightMax] = (((_d = filtersWithoutBasicQueryParams['height']) === null || _d === void 0 ? void 0 : _d[0]) || '').split('-');
            filtersWithoutBasicQueryParams['height'] = [
                `${convertInchesToCentimeters(heightMin)}-${convertInchesToCentimeters(heightMax)}`,
            ];
        }
    }
    // Format curated_status to map values like -1 that in slugify can't be in URL
    if (Boolean(filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams['curated_status_value'])) {
        const curatedStatus = filtersWithoutBasicQueryParams['curated_status_value'].map((curatedValue) => constants_2.CURATED_STATUS_MAPPING_VALUES[curatedValue]);
        filtersWithoutBasicQueryParams['curated_status'] = curatedStatus;
        delete filtersWithoutBasicQueryParams['curated_status_value'];
    }
    const facetsToSend = Object.fromEntries(Object.entries(filtersWithoutBasicQueryParams).filter(([key]) => allowedFacetNames.includes(key)));
    return facetsToSend;
};
exports.rulesToSendFilters = rulesToSendFilters;
const getAspectRatio = ({ isPrintsPage, aspectRatio = 1, printAspectRatio = 1, }) => {
    return isPrintsPage ? printAspectRatio : aspectRatio;
};
exports.getAspectRatio = getAspectRatio;
// Create a LIST of Shared Facets ** Slugifid Version **
// We use this to make sure we dont create a URL path of `/abstract/abstract`
// We will allow a second parameter for letting us know the order of importance
// We want to know what FacetName should take precedence
// facets: { styles: {'abstract': ...}, subject: {'abstract': ...}, }
// Result => { abstract: ['style', 'subject'] } OR { attibuteName: { facetName, facetName }}
const sharedFacetNameList = (dictionary, pathParams) => {
    const pathKeys = pathParams || Object.keys(dictionary);
    const list = pathKeys.reduce((results, facetName) => {
        const dictionaryValues = dictionary[facetName];
        if (dictionaryValues) {
            // Build out List of Items { abstract: [ 'styles', 'subject' ], paper: [ 'mediums' ], ...}
            Object.keys(dictionaryValues).forEach((attributeName) => {
                if (results[attributeName]) {
                    // If Key VALUE exist, merge values together
                    results[attributeName] = [...results[attributeName], facetName];
                }
                else {
                    results[attributeName] = [facetName];
                }
            });
        }
        return results;
    }, {});
    // Filter List Down to items containing 2 Items
    return Object.entries(list).reduce((filteredList, [attibuteName, facetNames]) => (Object.assign(Object.assign({}, filteredList), (Array.isArray(facetNames) && facetNames.length !== 1
        ? {
            [attibuteName]: facetNames,
        }
        : null))), {});
};
exports.sharedFacetNameList = sharedFacetNameList;
// Expects a object => { "Abstract": 897, "Fine Art": 638, "Abstract Expressionism": 450, ... }
// Will return a new Object => { abstract: "Abstract", "fine-art", "Fine Art", "abstract-expressionism": "Abstract Expressionism", ... }
const buildSlugifyObject = (obj) => Object.keys(obj).reduce((results, key) => (Object.assign(Object.assign({}, results), { [(0, slugify_1.slugify)(key)]: key === null || key === void 0 ? void 0 : key.toLowerCase() })), {});
const buildObject = (obj) => Object.keys(obj).reduce((results, key) => (Object.assign(Object.assign({}, results), { [key]: key === null || key === void 0 ? void 0 : key.toLowerCase() })), {});
// Expects a object => { facets: { "Abstract": 897, "Fine Art": 638, "Abstract Expressionism": 450, ... } }
// Will return a new Object => { facets: { abstract: "Abstract", "fine-art", "Fine Art", "abstract-expressionism": "Abstract Expressionism", ... } }
const buildConstructorSlugifyDictionary = (obj) => Object.entries(obj).reduce((results, [key, value]) => key.search(/curated_status/) > -1 // Skip these values - do NOT slugify
    ? Object.assign(Object.assign({}, results), { [key]: buildObject(value) }) : Object.assign(Object.assign({}, results), { [key]: buildSlugifyObject(value) }), {});
exports.buildConstructorSlugifyDictionary = buildConstructorSlugifyDictionary;
// We use this FILE both SSR and Clientside, so NO FLOW
// We want to have a clean state/reset state
// (['style', 'category', ...]) => { style: [], category: [], ...}
const resetSelectedFacets = (facetNames) => facetNames.reduce((results, facetName) => (Object.assign(Object.assign({}, results), { [facetName]: [] })), {});
// We need to find out what `FacetName` a `AttributeName` belongs to
// Array#some -> escape as soon as TRUE || Return value
const getFacetName = ({ dictionary, name, }) => {
    let facetNameMatch = '';
    // Loop through all facets
    Object.entries(dictionary).some(([facetName, attributes]) => {
        // Loop through Attributes and look for a matching attributeName
        Object.keys(attributes).some((attributeName) => {
            if (attributeName === name) {
                // Set the FacetName & Escape
                facetNameMatch = facetName;
                return facetNameMatch;
            }
        });
        if (facetNameMatch) {
            // Found the Match & Escape
            return facetNameMatch;
        }
    });
    return facetNameMatch;
};
/*
This function is meant to find all FacetValues and matching them back to FacetNames
Ex: '/painting/abstract' => { category: ['painting'], style: ['abstract']}
Uses position-based parsing: each URL segment corresponds to a facet by position in routeParams
`basePath` is an optional non-facet URL prefix (Ex: '/new-arrivals') that must be removed
before positional parsing so the remaining segments line up with routeParams.
*/
const getPathnameFacets = ({ dictionary, pathname, routeParams, booleanFacets = {}, basePath = '', }) => {
    if (!dictionary || !pathname) {
        // Missing Data - Return empty Object
        return {};
    }
    let emptySelectedFacets = [];
    let dictionaryLookup;
    if (routeParams && Array.isArray(routeParams)) {
        // We KNOW what values to look for, and in what ORDER
        emptySelectedFacets = resetSelectedFacets(routeParams);
        // Custom Dictionary with ONLY routeParams
        dictionaryLookup = routeParams.reduce((data, facetName) => {
            data[facetName] = dictionary[facetName] || {};
            return data;
        }, {});
    }
    else {
        // Create Empty Selected Values - All Values
        emptySelectedFacets = resetSelectedFacets(Object.keys(dictionary));
        // Use default Dictionary
        dictionaryLookup = dictionary;
    }
    // Remove Empty ITEMS Ex: '/some/url///thing' => ['', 'some', '', '', 'thing']
    const allSegments = pathname.split('/').filter(Boolean);
    // Strip the leading basePath segments (Ex: ['new-arrivals']) so the remaining
    // segments align positionally with routeParams. Only strip when the leading
    // segments actually match basePath, otherwise leave the pathname untouched.
    const baseSegments = (basePath || '').split('/').filter(Boolean);
    const hasBasePathPrefix = baseSegments.length > 0 &&
        baseSegments.every((segment, index) => allSegments[index] === segment);
    const list = hasBasePathPrefix ? allSegments.slice(baseSegments.length) : allSegments;
    // The position here is important since we have some values
    // that exist in multiple places (mediums and styles for example)
    const paramFacets = list.reduce((results, item, index) => {
        if (routeParams && Array.isArray(routeParams)) {
            const positionFacetName = routeParams[index];
            if (!positionFacetName) {
                return results;
            }
            // has_prints facet
            if (positionFacetName === 'has_prints' && item === 'prints') {
                return Object.assign(Object.assign({}, results), { has_prints: [true] });
            }
            // boolean facets
            if (booleanFacets[positionFacetName] === item) {
                return Object.assign(Object.assign({}, results), { [positionFacetName]: ['true'] });
            }
            // Try position-based lookup first
            const positionFacetDict = dictionaryLookup[positionFacetName] || {};
            if (positionFacetDict[item] !== undefined) {
                return Object.assign(Object.assign({}, results), { [positionFacetName]: [item] });
            }
            // Position mismatch: check all boolean facets (they can appear at any URL position)
            for (const [key, value] of Object.entries(booleanFacets)) {
                if (value === item && !results[key]) {
                    return Object.assign(Object.assign({}, results), { [key]: ['true'] });
                }
            }
            // Last resort : search only page-scoped facets — dictionaryLookup excludes
            // materials on prints pages and print_materials on originals pages, so shared
            // slugs like canvas resolve to the correct facet without ambiguity
            const actualFacetName = getFacetName({
                dictionary: dictionaryLookup,
                name: item,
            });
            if (actualFacetName && !results[actualFacetName]) {
                return Object.assign(Object.assign({}, results), { [actualFacetName]: [item] });
            }
            return results;
        }
        // Fallback for when routeParams is not available
        // Escape and Set Prints
        if (item === 'prints') {
            return Object.assign(Object.assign({}, results), { has_prints: [true] });
        }
        for (const [key, value] of Object.entries(booleanFacets)) {
            if (value === item) {
                return Object.assign(Object.assign({}, results), { [key]: ['true'] });
            }
        }
        // Find Values => FacetName (first-match lookup - only used as fallback)
        const facetName = getFacetName({
            dictionary: dictionaryLookup,
            name: item,
        });
        // Make sure it doesn't already exist, exit early/move to next param
        // Also don't create a entry if doesn't match a facetName
        if (!facetName || results[facetName]) {
            return results;
        }
        // Add to Results
        return Object.assign(Object.assign({}, results), { [facetName]: [item] });
    }, {});
    return Object.assign(Object.assign({}, emptySelectedFacets), paramFacets);
};
// Ex: [ 'fine-art', 'fine-art', 'conceptual', 'impressionism', 'modern', 'conceptual']
// Results ['fine-art', 'conceptual', 'impressionism', 'modern',]
const restrictDuplicateValues = (facetValue) => {
    if (Array.isArray(facetValue)) {
        return facetValue.reduce(
        // if Item Exist, Return Results, else Append Item to Results
        (results, item) => (results.includes(item) ? results : [...results, item]), []);
    }
    // Single Object/String - Do Nothing
    return facetValue;
};
/*
We want to merge params and query together to create our Current Selected Facets
Params are ALWAYS types of Arrays and should also be EMPTY ARRAYS if not set
Ex: Params => { category: ['painting'], styles: [] }, Query => { styles: [abstract],  is_framed: 'true'}
Results => { category: ['painting'], styles: [abstract],  is_framed: 'true' }
*/
const mergeParamsQueryFacets = ({ params, query }) => {
    if (!params || !query) {
        return {};
    }
    const selectedFacets = Object.assign({}, params);
    // merge parameters existing in two or more of the same query objects into an array
    Object.entries(query).forEach(([dirtyFacetName, facetValue]) => {
        // Lets also fix an issue with Parsing Queries and Remove Brackets
        // PROBLEM: We have to convert to create urls styles => ?styles[]=
        // Ex: query = { 'styles[]': ['abstract'] } => { styles: ['abstract'] }
        // CODE => `.replace(/\[\]/g, '')`
        const facetName = dirtyFacetName.replace(/\[\]/g, ''); // CLEAN Version
        // Value exists already
        if (selectedFacets[facetName]) {
            if (Array.isArray(facetValue)) {
                // If query value is already an array, concatenate array values
                selectedFacets[facetName] = [...selectedFacets[facetName], ...facetValue];
            }
            else {
                // Otherwise, make it an array, then concatenate values
                selectedFacets[facetName] = [...(selectedFacets[facetName] || []), facetValue];
            }
        }
        else {
            // New value, add it
            selectedFacets[facetName] = Array.isArray(facetValue) ? facetValue : [facetValue];
        }
    });
    // Sanity Check, No Duplicate FacetValues
    Object.entries(selectedFacets).forEach(([facetName, facetValue]) => (selectedFacets[facetName] = restrictDuplicateValues(facetValue)));
    return selectedFacets;
};
// Check Dictionary For Value OR return default (slugify) Value
// LOWER CASE NOW AS ALL VALUES ARE BEING LOWER CASE ON BACKEND FOR CONSTRUCTOR
const dictionaryLookup = ({ dictionary, facetName, facetValue }) => {
    var _a;
    return ((dictionary[facetName] && ((_a = dictionary[facetName][facetValue]) === null || _a === void 0 ? void 0 : _a.toLowerCase())) ||
        (facetValue === null || facetValue === void 0 ? void 0 : facetValue.toLowerCase()));
};
// Turn Slug back to Natural Values
const convertSlugifiedFacetsToNaturalValues = ({ dictionary, slugifiedFacets }) => {
    const slugifiedResults = Object.assign({}, slugifiedFacets);
    Object.entries(slugifiedFacets).forEach(([facetName, facetValue]) => {
        // Does the FacetName exist in dictionary, unslugify values
        if (dictionary === null || dictionary === void 0 ? void 0 : dictionary[facetName]) {
            slugifiedResults[facetName] = Array.isArray(facetValue)
                ? facetValue.reduce((list, name) => [
                    ...list,
                    dictionaryLookup({
                        dictionary,
                        facetName,
                        facetValue: name,
                    }),
                ], [])
                : dictionaryLookup({
                    dictionary,
                    facetName,
                    facetValue,
                });
        }
    });
    return slugifiedResults;
};
const parseUrlFacets = ({ dictionary, href, routeParams, booleanFacets = {}, basePath = '', }) => {
    const { pathname, query } = (0, url_1.parse)(href, true);
    // Query will already be PRETTY & Parsed, still need to parse pathname
    const paramsFacets = getPathnameFacets({
        dictionary,
        pathname,
        routeParams,
        booleanFacets,
        basePath,
    });
    const mergedFacets = mergeParamsQueryFacets({
        params: paramsFacets,
        query,
    });
    const naturalValues = convertSlugifiedFacetsToNaturalValues({
        dictionary,
        slugifiedFacets: mergedFacets,
    });
    return naturalValues;
};
exports.parseUrlFacets = parseUrlFacets;
const getSortValues = ({ sort, destinationZone = '' }) => {
    const isSortByPrice = [facetNames_1.SORT_VALUES.PRICE_LOW_TO_HIGH, facetNames_1.SORT_VALUES.PRICE_HIGH_TO_LOW].includes(sort);
    const sortObject = Object.assign({}, (facetNames_1.SORT_BY_AND_ORDER[sort] || { sortBy: '', sortOrder: '' }));
    // Needed to include destination zone in the sorting by price
    if (isSortByPrice) {
        sortObject.sortBy = `${facetNames_1.SORT_BY_AND_ORDER[sort].sortBy}-${destinationZone}`;
    }
    return sortObject;
};
exports.getSortValues = getSortValues;
function isSafeRedirectUrl(url) {
    try {
        const isJavascriptAttack = /javascript:/i.test(url);
        const isDataAttack = /data:/i.test(url);
        const isOnCallbackAttack = /\bon\w+=/g.test(url);
        const isScriptAttack = /<\s*script\s*>/gi.test(url);
        if (isJavascriptAttack || isDataAttack || isOnCallbackAttack || isScriptAttack) {
            return false;
        }
        // Encode parameters
        const sanitizedUrl = encodeURI(url);
        const parsedUrl = new URL(sanitizedUrl);
        // Ensure it uses HTTP or HTTPS
        if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
            return false;
        }
        return true;
    }
    catch (e) {
        return false;
    }
}
